import script from "./TreatmentsTrials.vue?vue&type=script&setup=true&lang=js"
export * from "./TreatmentsTrials.vue?vue&type=script&setup=true&lang=js"

import "./TreatmentsTrials.vue?vue&type=style&index=0&id=e0a56de2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e0a56de2"]])

export default __exports__